import { format } from 'date-fns';
import type { ShowInfoByIdResponse } from '../models/show.interface';

export interface TimeSlot {
  time: string;
  price: string;
  date: string;
  showId: number;
  eventId: number;
}

/**
 * Фильтрация событий по конкретной дате в формате 'yyyy-MM-dd'
 */
export const filterEventsByDate =
  (formattedDate: string) => (event: ShowInfoByIdResponse['events'][0]) => {
    const eventDate = event.from.split('T')[0];
    return eventDate === formattedDate;
  };

/**
 * Фильтрация событий по ID события
 */
export const filterEventById = (eventId?: number) => (event: ShowInfoByIdResponse['events'][0]) => {
  return eventId ? event.id === eventId : true;
};

/**
 * Форматирование события в тайм-слот
 */
export const formatEventToTimeSlot = (event: ShowInfoByIdResponse['events'][0]): TimeSlot => {
  const eventDate = new Date(event.from);
  const timeString = format(eventDate, 'HH:mm');
  const dateString = format(eventDate, 'dd.MM.yyyy');

  return {
    time: timeString,
    price: String(event.minimalPrice),
    date: dateString,
    showId: event.showId,
    eventId: event.id,
  };
};

/**
 * Функция для формирования массива тайм-слотов из событий
 * @param events - массив событий из данных шоу
 * @param options - опции фильтрации
 * @returns массив тайм-слотов
 */
export const formatTimeSlots = (
  events: ShowInfoByIdResponse['events'],
  options?: {
    formattedDate?: string; // Дата в формате 'yyyy-MM-dd'
    eventId?: number; // ID события
  }
): TimeSlot[] => {
  if (!events || !events.length) {
    return [];
  }

  let filteredEvents = [...events];

  // Применяем фильтры в зависимости от переданных опций
  if (options?.formattedDate) {
    filteredEvents = filteredEvents.filter(filterEventsByDate(options.formattedDate));
  }

  if (options?.eventId) {
    filteredEvents = filteredEvents.filter(filterEventById(options.eventId));
  }

  // Преобразуем отфильтрованные события в тайм-слоты
  return filteredEvents.map(formatEventToTimeSlot);
};
